export const ERRORS = {
  INVALID_ACCESS_TOKEN: 'INVALID_ACCESS_TOKEN',
  POPUP_NOT_FOUND: 'POPUP_NOT_FOUND',
  USER_POPUP_DUPLICATED_ERROR: 'USER_POPUP_DUPLICATED_ERROR',
  USER_COUPON_DUPLICATED_ERROR: 'USER_COUPON_DUPLICATED_ERROR',
  COUPON_INVALID: 'COUPON_INVALID',
  COUPON_REDEEM_FAILED: 'COUPON_REDEEM_FAILED',
  COUPON_ENGAGE_FAILED: 'COUPON_ENGAGE_FAILED',
  COUPON_PAGEID_UNMATCHED: 'COUPON_PAGEID_UNMATCHED',
  COUPON_EXPIRED: 'COUPON_EXPIRED',
  USER_COUPON_NOT_FOUND: 'USER_COUPON_NOT_FOUND',
  COUPON_ROULETTE_COUNT_ZERO: 'COUPON_ROULETTE_COUNT_ZERO',
};

export default {
  ERRORS,
};
